export const TERMINAL_NODE_ID = 'terminal';
